import { BOT_ZIGZAG_URL, INDEX_SENTIMENT_URL } from "env";
import Layout from "Layout";
import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";

const ToolFrame: React.FC = () => {
    const { id } = useParams<{ id: string }>();
    const [theme, setTheme] = useState<string>('light');
    const iframeRef = useRef<HTMLIFrameElement>(null);

    const iframeSrc = id === "283" ? BOT_ZIGZAG_URL : INDEX_SENTIMENT_URL;

    useEffect(() => {

        const authToken = localStorage.getItem('token');

        const htmlTag = document.documentElement;
        const initialTheme = htmlTag.classList.contains('theme-dark') ? 'dark' : 'light';
        setTheme(initialTheme);

        const language = localStorage.getItem('i18nextLng');

        const handleMessage = (event: MessageEvent) => {
            if (event.origin !== iframeSrc) return;
            if (event.data.type === 'requestConfig' && authToken && iframeRef.current) {
                iframeRef.current.contentWindow?.postMessage(
                    {
                        type: 'config',
                        token: authToken,
                        theme: initialTheme,
                        language: language || 'en',
                    },
                    iframeSrc
                );
            }
        };

        const observer = new MutationObserver(() => {
            const currentTheme = htmlTag.classList.contains('theme-dark') ? 'dark' : 'light';
            if (currentTheme !== theme) {
                setTheme(currentTheme);
                if (iframeRef.current && authToken) {
                    iframeRef.current.contentWindow?.postMessage(
                        {
                            type: 'config',
                            token: authToken,
                            theme: currentTheme,
                            language: language || 'en',
                        },
                        iframeSrc
                    );
                }
            }
        });

        observer.observe(htmlTag, { attributes: true, attributeFilter: ['class'] });

        window.addEventListener('message', handleMessage);

        // Cleanup
        return () => {
            window.removeEventListener('message', handleMessage);
            observer.disconnect();
        };
    }, [theme]);

    return (
        <Layout>
            <iframe
                src={iframeSrc}
                ref={iframeRef}
                style={{ width: '100%', height: '100vh', borderRadius: '5px', margin: '-8px' }}
            ></iframe>
        </Layout>
    )
}

export default ToolFrame